import { useContext, useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ThinFooter from "../Footer/ThinFooter";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import { HeadingWrapper } from "../Atomics/SectionHeader/SectionHeader";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { NavDropdown, Tab, Tabs } from "react-bootstrap";
import BasicTable from "../Atomics/Table";
import StackedBarChart from "../Atomics/StackBarChart";
import VideoCard from "../Atomics/VideoCard/VideoCard";
import {
  campaignReportFetcher,
  paginate,
  reportFetcher,
} from "../../api/requests";
import DateObject from "react-date-object";
import LoadingIndicator from "../Atomics/Loading/Loading";
import { CategoryContext } from "../../context/categories";
import Paginate from "../Atomics/Paginate/Paginate";
import { useLocation } from "react-router-dom";
import { TagsContext } from "../../context/tag";

const Statistics = () => {
  const [fromDate, setFromDate] = useState(
    new DateObject({ calendar: persian, locale: persian_fa }).subtract(2, "day")
  );
  const [toDate, setToDate] = useState(
    new DateObject({ calendar: persian, locale: persian_fa })
  );
  const [filteredData, setFilteredData] = useState([]);
  const [filteredTotalData, setFilteredTotalData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { categories, subCategories } = useContext(CategoryContext);
  const { tags } = useContext(TagsContext);
  const [selectedCatId, setSelectedCatId] = useState(null);
  const [selectedCat, setSelectedCat] = useState("دسته بندی ها");
  const [selectedSubCatId, setSelectedSubCatId] = useState(null);
  const [selectedSubCat, setSelectedSubCat] = useState("زیردسته ها");
  const [selectedTagId, setSelectedTagId] = useState(null);
  const [selectedTag, setSelectedTag] = useState("تگ ها");
  const [paginationInfo, setPaginationInfo] = useState({});
  const location = useLocation();
  const campaign = new URLSearchParams(location.search).get("campaign");

  const [tab, setTab] = useState("اطلاعات کلی");

  const convertToEnglishDigits = (date) =>
    date ? date.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d)) : null;

  const formatDate = (dateObj) =>
    convertToEnglishDigits(dateObj.format("YYYY-MM-DD"));

  const fetchFilteredData = async (
    catId = selectedCatId,
    catName = selectedCat,
    subCatId = selectedSubCatId,
    subCatName = selectedSubCat,
    tagId = selectedTagId,
    tagName = selectedTag
  ) => {
    setSelectedCatId(catId);
    setSelectedCat(catId ? catName : "دسته بندی ها");

    setSelectedSubCatId(subCatId);
    setSelectedSubCat(subCatId ? subCatName : "زیردسته ها");

    setSelectedTagId(tagId);
    setSelectedTag(tagId ? tagName : "تگ ها");

    setLoading(true);
    try {
      let res, totalRes;
      const start = formatDate(fromDate);
      const end = formatDate(toDate);

      if (catId || subCatId || tagId) {
        res = campaign
          ? await campaignReportFetcher.getByCategory(
              start,
              end,
              catId,
              subCatId,
              tagId
            )
          : await reportFetcher.getByCategory(
              start,
              end,
              catId,
              subCatId,
              tagId
            );

        totalRes = campaign
          ? await campaignReportFetcher.getByCategoryForChart(
              start,
              end,
              catId,
              subCatId,
              tagId
            )
          : await reportFetcher.getTotalData(
              start,
              end,
              catId,
              subCatId,
              tagId
            );
      } else {
        res = campaign
          ? await campaignReportFetcher.get(start, end)
          : await reportFetcher.get(start, end);

        totalRes = campaign
          ? await campaignReportFetcher.getTotalData(start, end)
          : await reportFetcher.getTotalData(start, end);
      }

      setFilteredData(res);
      setPaginationInfo(res);
      setFilteredTotalData(totalRes);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDateRangeFilter = () => {
    fetchFilteredData();
  };

  const handleCatSelection = (catId, catName) => {
    fetchFilteredData(
      catId,
      catName,
      selectedSubCatId,
      selectedSubCat,
      selectedTagId,
      selectedTag
    );
  };

  const handleSubCatSelection = (subCatId, subCatName) => {
    fetchFilteredData(
      selectedCatId,
      selectedCat,
      subCatId,
      subCatName,
      selectedTagId,
      selectedTag
    );
  };

  const handleTagSelection = (tagId, tagName) => {
    fetchFilteredData(
      selectedCatId,
      selectedCat,
      selectedSubCatId,
      selectedSubCat,
      tagId,
      tagName
    );
  };

  const handlePageChange = async (arg) => {
    setLoading(true);

    try {
      let res;

      if (typeof arg === "string") {
        const startIndex = arg.indexOf("api") + 3;
        res = await paginate.get(arg.slice(startIndex));
      } else if (typeof arg === "object" && arg.baseUrl && arg.page) {
        res = await paginate.getByNumber(arg.baseUrl, arg.page);
      } else {
        res = arg;
      }

      setFilteredData(res);
      setPaginationInfo(res);
    } catch (error) {
      console.error("Error fetching page:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFilteredData();
  }, [campaign]);

  return (
    <ContentWrapper>
      <Container
        fluid
        className="upload-details text-right"
        style={{
          paddingLeft: "30px",
          paddingRight: "30px",
          minHeight: "calc(100vh - 123px)",
        }}
      >
        <div
          style={{
            paddingTop: "30px",
            paddingLeft: "30px",
            paddingRight: "30px",
          }}
        >
          <Row>
            <Col>
              <div className="float-right">
                <HeadingWrapper
                  heading={
                    campaign ? "گزارش گیری پویش ها" : "گزارش گیری کانال ها"
                  }
                />
              </div>
            </Col>
          </Row>

          {/* Date Filter */}
          <Row className="p-3" style={{ gap: "8px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span>از</span>
              <DatePicker
                value={fromDate}
                onChange={setFromDate}
                calendar={persian}
                locale={persian_fa}
                placeholder="تاریخ شروع"
                className="teal"
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "8px",
                  width: "100%",
                }}
              />
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span>تا</span>
              <DatePicker
                value={toDate}
                onChange={setToDate}
                calendar={persian}
                locale={persian_fa}
                placeholder="تاریخ پایان"
                className="teal"
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "8px",
                  width: "100%",
                }}
              />
            </div>

            <div>
              <button
                className="btn btn-primary py-0"
                onClick={handleDateRangeFilter}
                style={{ width: "100%", fontSize: "14px" }}
              >
                فیلتر
              </button>
            </div>
          </Row>

          {/* Tabs */}
          <Row className="py-3">
            <Col>
              <Tabs
                id="controlled-tab-example"
                activeKey={tab}
                onSelect={(k) => setTab(k)}
                className="mb-3"
              >
                {/* Tab 1 */}
                <Tab eventKey="اطلاعات کلی" title="اطلاعات کلی">
                  <div className="mb-3 d-flex justify-content-start">
                    <NavDropdown
                      title={<span className="pl-2">{selectedCat}</span>}
                      id=""
                      className="customDropdownStyle catDropdown osahan-right-navbar-user user-dropdown-link"
                    >
                      <span
                        style={{ textAlign: "right", cursor: "pointer" }}
                        className="dropdown-item"
                        onClick={() =>
                          fetchFilteredData(
                            null,
                            "دسته بندی ها",
                            selectedSubCatId,
                            selectedSubCat,
                            selectedTagId,
                            selectedTag
                          )
                        }
                      >
                        همه دسته‌بندی‌ها
                      </span>
                      {categories?.length > 0 ? (
                        categories.map((item, index) => (
                          <span
                            style={{
                              textAlign: "right",
                              cursor: "pointer",
                            }}
                            key={item?.id || index}
                            className="dropdown-item"
                            role="button"
                            onClick={() =>
                              handleCatSelection(item?.id, item?.name)
                            }
                          >
                            {item?.name}
                          </span>
                        ))
                      ) : (
                        <div className="dropdown-item text-muted">
                          دسته‌بندی‌ای وجود ندارد
                        </div>
                      )}
                    </NavDropdown>
                    <NavDropdown
                      title={<span className="pl-2">{selectedSubCat}</span>}
                      id=""
                      className="customDropdownStyle catDropdown osahan-right-navbar-user user-dropdown-link"
                    >
                      <span
                        style={{ textAlign: "right", cursor: "pointer" }}
                        className="dropdown-item"
                        onClick={() =>
                          fetchFilteredData(
                            selectedCatId,
                            selectedCat,
                            null,
                            "زیردسته ها",
                            selectedTagId,
                            selectedTag
                          )
                        }
                      >
                        همه زیردسته ها
                      </span>
                      {subCategories?.length > 0 ? (
                        subCategories.map((item, index) => (
                          <span
                            style={{
                              textAlign: "right",
                              cursor: "pointer",
                            }}
                            key={item?.id || index}
                            className="dropdown-item"
                            role="button"
                            onClick={() =>
                              handleSubCatSelection(item?.id, item?.name)
                            }
                          >
                            {item?.name}
                          </span>
                        ))
                      ) : (
                        <div className="dropdown-item text-muted">
                          زیردسته ای وجود ندارد
                        </div>
                      )}
                    </NavDropdown>
                    <NavDropdown
                      title={<span className="pl-2">{selectedTag}</span>}
                      id=""
                      className="customDropdownStyle catDropdown osahan-right-navbar-user user-dropdown-link"
                    >
                      <span
                        style={{ textAlign: "right", cursor: "pointer" }}
                        className="dropdown-item"
                        onClick={() =>
                          fetchFilteredData(
                            selectedCatId,
                            selectedCat,
                            selectedSubCatId,
                            selectedSubCat,
                            null,
                            "تگ ها"
                          )
                        }
                      >
                        همه تگ ها
                      </span>
                      {tags?.results?.length > 0 ? (
                        tags?.results?.map((item, index) => (
                          <span
                            style={{
                              textAlign: "right",
                              cursor: "pointer",
                            }}
                            key={item?.id || index}
                            className="dropdown-item"
                            role="button"
                            onClick={() =>
                              handleTagSelection(item?.id, item?.name)
                            }
                          >
                            {item?.name}
                          </span>
                        ))
                      ) : (
                        <div className="dropdown-item text-muted">
                          تگی وجود ندارد
                        </div>
                      )}
                    </NavDropdown>
                  </div>
                  {loading ? (
                    <LoadingIndicator />
                  ) : filteredData.count > 0 ? (
                    <>
                      <StackedBarChart
                        data={filteredTotalData}
                        keys={
                          campaign
                            ? [
                                "all_view",
                                "all_like",
                                "all_dislike",
                                "all_comments",
                                "all_post",
                                "all_save",
                                "all_share",
                                "senders_count",
                                "subscribe_count",
                                "all_rate",
                              ]
                            : [
                                "all_view",
                                "all_like",
                                "all_dislike",
                                "all_comments",
                                "all_post",
                                "all_save",
                                "all_share",
                                "repost_count",
                                "subscribe_count",
                              ]
                        }
                        colors={[
                          "#CDB4DB",
                          "#77DD77",
                          "#FF6961",
                          "#FFB347",
                          "#89CFF0",
                          "#FFD700",
                          "#FF9AA2",
                          "#addbcaff",
                          "#979dd6ff",
                          "#e0caa5ff",
                        ]}
                        xAxisKey={campaign ? "campaign__name" : "channel__name"}
                        height={400}
                      />
                      <br />
                      <BasicTable
                        cols={
                          campaign
                            ? [
                                "نام پویش",
                                "مجموع ویدئوها",
                                "مجموع بازدید",
                                "مجموع لایک",
                                "مجموع دیسلایک",
                                "مجموع ذخیره",
                                "مجموع اشتراک",
                                "مجموع نظرات",
                                "تعداد ارسال کنندگان",
                                "تعداد اعضاء",
                                "مجموع امتیازات",
                                "وضعیت",
                              ]
                            : [
                                "نام کانال",
                                "مجموع ویدئوها",
                                "مجموع بازدید",
                                "مجموع لایک",
                                "مجموع دیسلایک",
                                "مجموع ذخیره",
                                "مجموع اشتراک",
                                "مجموع نظرات",
                                "تعداد بازنشر",
                                "تعداد اعضاء",
                              ]
                        }
                        rows={filteredTotalData}
                        campaign={campaign}
                      />
                    </>
                  ) : (
                    <p>داده ای در این تاریخ وارد نشده است.</p>
                  )}
                </Tab>

                {/* Tab 2 */}
                <Tab eventKey="مستندات" title="مستندات">
                  <Container>
                    <div className="mb-3 d-flex justify-content-start">
                      <NavDropdown
                        title={<span className="pl-2">{selectedCat}</span>}
                        id=""
                        style={{ marginBottom: "5px", width: "fit-content" }}
                        className="customDropdownStyle catDropdown osahan-right-navbar-user user-dropdown-link"
                      >
                        <span
                          style={{ textAlign: "right", cursor: "pointer" }}
                          className="dropdown-item"
                          onClick={() =>
                            fetchFilteredData(
                              null,
                              "دسته بندی ها",
                              selectedSubCatId,
                              selectedSubCat,
                              selectedTagId,
                              selectedTag
                            )
                          }
                        >
                          همه استان ها
                        </span>
                        {categories?.length > 0 ? (
                          categories?.map((item, index) => (
                            <span
                              key={index}
                              style={{ textAlign: "right", cursor: "pointer" }}
                              className="dropdown-item"
                              role="button"
                              onClick={() =>
                                handleCatSelection(item.id, item.name)
                              }
                            >
                              {item.name}
                            </span>
                          ))
                        ) : (
                          <div
                            style={{
                              fontSize: "12px",
                              textAlign: "start",
                              paddingRight: "5px",
                            }}
                          >
                            دسته بندی ای وجود ندارد.
                          </div>
                        )}
                      </NavDropdown>
                      <NavDropdown
                        title={<span className="pl-2">{selectedSubCat}</span>}
                        id=""
                        className="customDropdownStyle catDropdown osahan-right-navbar-user user-dropdown-link"
                      >
                        <span
                          style={{ textAlign: "right", cursor: "pointer" }}
                          className="dropdown-item"
                          onClick={() =>
                            fetchFilteredData(
                              selectedCatId,
                              selectedCat,
                              null,
                              "زیردسته ها",
                              selectedTagId,
                              selectedTag
                            )
                          }
                        >
                          همه زیردسته ها
                        </span>
                        {subCategories?.length > 0 ? (
                          subCategories.map((item, index) => (
                            <span
                              style={{
                                textAlign: "right",
                                cursor: "pointer",
                              }}
                              key={item?.id || index}
                              className="dropdown-item"
                              role="button"
                              onClick={() =>
                                handleSubCatSelection(item?.id, item?.name)
                              }
                            >
                              {item?.name}
                            </span>
                          ))
                        ) : (
                          <div className="dropdown-item text-muted">
                            زیردسته ای وجود ندارد
                          </div>
                        )}
                      </NavDropdown>
                      <NavDropdown
                        title={<span className="pl-2">{selectedTag}</span>}
                        id=""
                        className="customDropdownStyle catDropdown osahan-right-navbar-user user-dropdown-link"
                      >
                        <span
                          style={{ textAlign: "right", cursor: "pointer" }}
                          className="dropdown-item"
                          onClick={() =>
                            fetchFilteredData(
                              selectedCatId,
                              selectedCat,
                              selectedSubCatId,
                              selectedSubCat,
                              null,
                              "تگ ها"
                            )
                          }
                        >
                          همه تگ ها
                        </span>
                        {tags?.results?.length > 0 ? (
                          tags?.results?.map((item, index) => (
                            <span
                              style={{
                                textAlign: "right",
                                cursor: "pointer",
                              }}
                              key={item?.id || index}
                              className="dropdown-item"
                              role="button"
                              onClick={() =>
                                handleTagSelection(item?.id, item?.name)
                              }
                            >
                              {item?.name}
                            </span>
                          ))
                        ) : (
                          <div className="dropdown-item text-muted">
                            تگی وجود ندارد
                          </div>
                        )}
                      </NavDropdown>
                    </div>
                    {loading ? (
                      <LoadingIndicator />
                    ) : filteredData.count > 0 ? (
                      <>
                        <Row>
                          {filteredData.results.map((item, index) => (
                            <Col
                              key={item?.id || index}
                              xs={12}
                              sm={6}
                              md={4}
                              lg={3}
                              className="mb-4"
                            >
                              <VideoCard
                                imgSrc={item?.cover || "img/v4.png"}
                                videoTitle={item?.title}
                                videoCategory={item?.categorys.name}
                                views={item?.counted_views}
                                timeAgo={item?.published_date}
                                totalLikes={item?.counted_like}
                                totalDislikes={item?.counted_dislike}
                                totalSaves={item?.counted_save}
                                totalShares={item?.counted_share}
                                imgHref={
                                  campaign
                                    ? `/video-page/${item?.id}/?campaign=${item?.campaign?.id}&category=${item?.categorys?.id}`
                                    : `/video-page/${item?.id}`
                                }
                                iconHref={
                                  campaign
                                    ? `/video-page/${item?.id}/?campaign=${item?.campaign?.id}&category=${item?.categorys?.id}`
                                    : `/video-page/${item?.id}`
                                }
                                videoTitleHref={
                                  campaign
                                    ? `/video-page/${item?.id}/?campaign=${item?.campaign?.id}&category=${item?.categorys?.id}`
                                    : `/video-page/${item?.id}`
                                }
                                videoId={item?.id}
                                channelName={
                                  campaign
                                    ? item?.campaign?.name
                                    : item?.channel?.name
                                }
                                channelId={
                                  campaign
                                    ? item?.campaign?.id
                                    : item?.channel?.id
                                }
                                campaign={campaign}
                              />
                            </Col>
                          ))}
                        </Row>
                      </>
                    ) : (
                      <p>داده ای در این تاریخ وارد نشده است.</p>
                    )}
                  </Container>
                </Tab>
              </Tabs>
              {tab === "مستندات" && (
                <Paginate
                  count={filteredData.count}
                  value={paginationInfo}
                  onPageChange={handlePageChange}
                  limit={12}
                />
              )}
            </Col>
          </Row>
        </div>
      </Container>

      <ThinFooter />
    </ContentWrapper>
  );
};

export default Statistics;
